module.exports = __webpack_public_path__ + "static/media/IMG_4827.e77dab7c.JPG";